<template>
  <div id="footerId">
    <div class="wrapper">
        <div class="flex">
          <div class="flex1">
          <div class="cardicon">

    <svg width="35" height="26" viewBox="0 0 35 26" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon2'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M32.51.996H6.192A2.334 2.334 0 003.87 3.327v1.555H2.322A2.334 2.334 0 000 7.213v16.32a2.334 2.334 0 002.322 2.332H28.64a2.334 2.334 0 002.322-2.331v-1.555h1.548a2.334 2.334 0 002.322-2.331V3.328A2.334 2.334 0 0032.51.995zm-3.096 22.538a.778.778 0 01-.774.777H2.322a.778.778 0 01-.774-.777v-9.326h27.866v9.326zm0-10.88H1.548v-2.332h27.866v2.331zm0-3.886H1.548V7.213c0-.427.348-.777.774-.777H28.64c.425 0 .774.35.774.777v1.555zm3.87 10.88a.778.778 0 01-.774.777h-1.548V7.213a2.334 2.334 0 00-2.322-2.331H5.418V3.327c0-.427.349-.777.774-.777H32.51c.426 0 .774.35.774.777v16.32zm-11.61 2.331c.464 0 .967-.116 1.354-.35.387.234.851.35 1.354.35 1.51 0 2.71-1.204 2.71-2.72 0-1.515-1.2-2.72-2.71-2.72-.464 0-.967.117-1.354.35-.387-.233-.852-.35-1.355-.35a2.698 2.698 0 00-2.709 2.72c0 1.516 1.2 2.72 2.71 2.72zm0-3.885c.309 0 .58.116.812.35.31.31.774.31 1.084 0 .232-.195.503-.35.812-.35.658 0 1.162.505 1.162 1.165 0 .622-.504 1.166-1.162 1.166-.31 0-.58-.117-.812-.35a.763.763 0 00-.542-.233.762.762 0 00-.542.233c-.232.233-.503.35-.813.35a1.167 1.167 0 01-1.16-1.166c0-.66.502-1.165 1.16-1.165z"/></svg>
   <p class="logo">Нужна<span>Кредитка!</span></p>
   </div>
   <div class="info">
     <p class='grayText'>ООО МКК "ФИНМОЛЛ" ОГРН 1186313065685, КПП 785250001
630112, г. Новосибирск, ул. Фрунзе, д.242, пом. 406
Находится в реестре операторов, осуществляющих обработку персональных данных, рег. № 54-15-001451, приказ № 28 от 18.02.2015
Данное соглашение действует бессрочно и может быть отозвано путем отправки заявления 
в свободной форме по email-адресу: otkaz@finmoll.com с пометкой в теме «Отказ от сотрудничества».
</p>
     </div>
   <p class="info2 grayText">НужнаКредитка! - сервис подбора кредитных карт.

<router-link class='grayText' to="/politika" target="_blank">Согласие на обработку персональных данных</router-link>
</p>

</div>

<div id="contactId">
<h2>Контакты</h2>
<div id="contact">
<div class="iconGrid">
<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.939 0A5.057 5.057 0 0120 5.05v7.9c0 2.79-2.27 5.05-5.061 5.05H5.06A5.057 5.057 0 010 12.95v-7.9A5.05 5.05 0 015.06 0h9.879zm1.591 6.54l.08-.08a.773.773 0 00-.011-1 .84.84 0 00-.529-.26.76.76 0 00-.561.2L11 9a1.566 1.566 0 01-2 0L4.5 5.4a.76.76 0 00-1 .07c-.27.27-.3.7-.071 1l.131.13 4.55 3.55a3.143 3.143 0 003.909 0l4.511-3.61z" fill="#DED3FF"/></svg>
<!-- <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M.008 8.695c0-.62.008-1.238.015-1.86.004-.314.008-.63.01-.947C.034 2.483 2.167 0 5.11 0h3.782c2.943 0 5.075 2.483 5.075 5.888.026 1.364.034 2.728.034 4.102s-.008 2.758-.034 4.122c0 3.405-2.132 5.888-5.075 5.888H5.109C2.166 20 .034 17.517.034 14.102.017 12.816 0 11.502 0 10.167l.008-1.472zM8.28 17.64v.16c0 .674-.563 1.2-1.28 1.2-.7 0-1.28-.526-1.28-1.2v-.16c0-.656.58-1.2 1.28-1.2.717 0 1.28.544 1.28 1.2zM2.017 6.443c-.006.404-.011.807-.011 1.209L2 8.608c0 .868.012 1.723.024 2.558C2.024 13.386 3.547 15 5.65 15h2.7c2.103 0 3.626-1.614 3.626-3.827.018-.887.024-1.786.024-2.68 0-.892-.006-1.78-.024-2.666C11.976 3.614 10.453 2 8.35 2h-2.7C3.547 2 2.024 3.614 2.024 5.827l-.007.616z" fill="#D6B1FF"/></svg> -->
<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.03 0c2.26.01 4.42.91 6 2.49a8.398 8.398 0 012.47 5.97v.05c-.06 3.03-1.76 5.82-3.88 8a22.12 22.12 0 01-3.98 3.24c-.39.33-.96.33-1.35 0-2.15-1.4-4.05-3.16-5.59-5.21A10.807 10.807 0 01.5 8.39C.52 3.74 4.34-.01 9.03 0zm0 11.26c.71 0 1.39-.27 1.89-.76.52-.51.811-1.189.811-1.9 0-1.48-1.211-2.67-2.701-2.67S6.34 7.12 6.34 8.6c0 1.461 1.18 2.64 2.66 2.66h.03z" fill="#D6B1FF"/></svg>
</div>
<ul>
  <li><a class="grayText" href="#">info@msk.finmoll.com</a></li>
  <!-- <li><a class="grayText href" href="#">8 800 600 99 90</a></li> -->
<li class="grayText">630112, Россия, г. Новосибирск,
ул. Фрунзе, д. 242, помещение 406</li>
</ul>
</div>
</div>
</div>
<p class="info2 grayText">Сервис бесплатный - за предоставление информации комиссия не взымается.
ВАЖНО: предоплату берут только мошенники!</p>
<div class="safety">
<p class="grayText safcard">НужнаКредитка<br>
© 2021  |  Все права защищены</p>
<div class="safety2">


  <router-link class='grayText' to="/sogl" target="_blank">Согласие на обработку персональных данных</router-link>
<svg width="18" height="2" viewBox="0 0 18 2" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'miniline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.537.216v.994H17.28V.216H.537z" fill="#D9DBE1"/></svg>
<!-- <a class="grayText href"
   href="/components/politika" target="_blank">Политика обработки персональных данных</a> -->
   <router-link class='grayText' to="/politika" target="_blank">Политика в отношении обработки персональных данных</router-link>
</div>
</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'footerComponents',
}
</script>

<style scoped>
span{color: #5F2EEA;}
#footerId{background-color: black; color: white;}
a{color: white;}
.cardicon{display: flex; align-items: center; padding-bottom: 8vw;}
.icon2{fill: white; padding-right: 1vw;}
p{padding-bottom: 8vw;}
p:last-child{padding-bottom: 0vw;}
.safety2{display: flex; flex-direction: column; }
.safcard{text-align: center; }
.href{text-decoration: none;}
.wrapper{padding:10vw 6vw;}
#contact{display:flex;}
.grayText{font-size: 4vw; color:#D9DBE1}
.iconGrid{text-align: center;}
.icon, li{ padding-top: 7vw;}
.icon{padding-right:2vw}
#contactId{padding-top: 12vw;}
.info2{ padding-top: 5.7vw;}
.ooo{line-height: 1.8;}
 @media screen and (min-width: 760px) {
   #footerWrap{padding:0vw 0vw;}
   .icon{width: 5vw;height: 5vw; }
 }
 @media screen and (min-width: 1140px) {
p{font-size: 18px; padding-bottom: 40px;}
.grayText{font-size: 19px;}
h2{font-size: 25px;}
.flex{display: flex; column-gap: 50px;}
.logo{font-size: 30px;font-weight: bold;}
.icon2{width:50px;height: 40px;}
.wrapper{padding-top:80px;padding-bottom:40px;}
.cardicon{padding-bottom: 35px;}
.icon{width: 30px;height: 30px; }
.icon, li{ padding-top: 40px;}
.flex1{width: 90%;}
.safcard{text-align: start;}
.safety{padding-top: 24px;}
#contactId{padding-top: 10px;}
.miniline{transform: rotate(270deg); width: 25px;height: 10px; }
.safety2{flex-direction: row; align-items: center;padding-top: 0px;}
.wrapper{width: 1035px;}
.info2{padding-top:40px;}
 }

</style>
